/* eslint-disable @typescript-eslint/no-explicit-any */
/* Employee — Salary Components. Labels state the calculation basis explicitly
   ("% of CTC" vs "% of Basic Salary") instead of ambiguous "Basic Salary %". */
import React from "react";
import Input, { reserveLabelLines } from "components/Input";
import DualModeInput from "components/Input/DualModeInput";
import { preventSpecialCharKeyDown } from "util/preventSpecialCharInput";
import { SectionCard, InfoNote } from "./_controls";

const EmployeeSalarySection = () => (
  <SectionCard title="Salary Components" subtitle="Define how the annual CTC is split into salary heads.">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-1" style={reserveLabelLines(2)}>
      <div>
        <Input
          compact
          name="basicSalaryPercentage"
          label="Basic Salary  ·  % of CTC"
          type="number"
          required
          placeholder="50.00"
          onKeyDown={preventSpecialCharKeyDown}
        />
        <InfoNote>Basic salary is calculated as a percentage of the employee&apos;s annual CTC.</InfoNote>
      </div>

      <Input
        compact
        name="hraPercentage"
        label="House Rent Allowance  ·  % of Basic Salary"
        type="number"
        required
        placeholder="40.00"
        onKeyDown={preventSpecialCharKeyDown}
      />

      <Input
        compact
        name="halfYearBonusPercentage"
        label="Half-Year Bonus  ·  % of Basic Salary"
        type="number"
        onKeyDown={preventSpecialCharKeyDown}
      />

      <Input
        compact
        name="performanceBonusPercentage"
        label="Performance Bonus  ·  % of Basic Salary"
        type="number"
        onKeyDown={preventSpecialCharKeyDown}
      />

      <div className="md:col-span-2 max-w-sm">
        {/* Reuses the existing DualModeInput for the %/₹ annual-bonus toggle. */}
        <DualModeInput
          compact
          name="annualBonusPercentage"
          flagName="annualBonusIsPercentage"
          percentageLabel="Annual Bonus (% of Basic Salary)"
          amountLabel="Annual Bonus (₹ / year)"
          defaultIsPercentage={true}
        />
      </div>
    </div>
  </SectionCard>
);

export default EmployeeSalarySection;
